// extracted by mini-css-extract-plugin
export default {"zoomModal":"W1-z","image":"X1-z","button":"Y1-z","isOverlayShown":"Z1-z"};